<div class="ap-explanation" data-testid="explanation-text">
    <ng-content></ng-content>
</div>
